import cat from "../assets/cat.png";
import cat2 from "../assets/cat-2.png";

function GiveAGift() {
    return (
        <>
            <section className="give-a-gift">
                <div className="container">
                    
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-4">
                            <div className="left-wrapper">
                                <h2>
                                    SAVING PETS NEAR YOU
                                </h2>
                                <p>
                                A dog or cat is put to sleep in America’s shelters every 90 seconds just because they don’t have a safe place to call home. <span className="important">You can help change that.</span>
                                </p>
                                <div className="img-bg">
                                    <img src={cat2} alt="cat" />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-12 col-lg-8">
                    
                                <div className="gift-wrapper">

                                    <div className="row">
                                    
                                        <div className="col-12 col-md-12 col-lg-6 text-part">
                                            <h2>
                                                Help more animals in 2025!
                                            </h2>
                                            <p>
                                                Your donation provides food, medical care, and safe shelter for pets in need. Make a difference today!
                                            </p>
                                            
                                            <a href="https://animalfoundation.com/donate" target="_blank">
                                                <button className="donate-button">
                                                    BECOME A DONATOR
                                                </button>
                                            </a>
                                        </div>
                                        
                                        <div className="col-12 col-md-12 col-lg-6">
                                            <div className="gift-img-wrapper">
                                                <img src={cat} alt="cat" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                        </div>
                    </div> 
                </div>
            </section>
        </>
    );
}

export default GiveAGift;